<template>
  <div class="strapi-components">
    <template v-for="c in article.content">
      <strapi-button
        v-if="c.component === 'generic.button'"
        :key="`${c.component}__${c.id}`"
        :component="cast<StrapiButton>(c)"
      />
      <strapi-product-content
        v-if="c.component === 'product.content'"
        :key="`${c.component}__${c.id}`"
        :component="cast<StrapiProductContent>(c)"
        :in-container="false"
      />
      <lazy-strapi-media-gallery
        v-if="c.component === 'media-gallery'"
        :key="`${c.component}__${c.id}`"
        :component="cast<StrapiMediaGallery>(c)"
        :in-container="false"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type {
  StrapiArticle,
  StrapiButton,
  StrapiMediaGallery,
  StrapiProductContent,
} from '~/apollo/types/types';

defineProps<{
  article: StrapiArticle;
}>();

const cast = <T,>(component) => component as T;
</script>
